export default __webpack_public_path__ + "static/media/MAIN Reedit EN_low.611e31fb.mp4";